export default __webpack_public_path__ + "static/media/darren-coleshill.c2c6ff6f.jpg";